export default function () {
	let $jivoBtn;
	const self = {};

	const _private = {
		findBtn: function () {
			window.ObserverUtil.observe('__jivoMobileButton', (node) => {
				$jivoBtn = $(node);
				self.changeJivoBtnPosition();
			});
		}
	};

	$.extend(self, {
		initEventListeners: function () {
		    $(window).on('scroll', self.changeJivoBtnPosition);
		},
		changeJivoBtnPosition: function (checkToCartBlock = true) {
			if ($jivoBtn !== undefined && $jivoBtn.length > 0) {
				const $fixedBar = $('.fixed-bar');
				const $addCartBlock = $('.to-cart__buy--main');

				let height = 0;

				if ($fixedBar.length > 0) {
					height = height + $fixedBar.outerHeight();
				}

				if ($addCartBlock.length > 0 && !$addCartBlock.hasClass('to-cart__buy--fixed') && checkToCartBlock) {
					ObserverUtil.observeClass('.to-cart__buy--main', function () {
						if ($addCartBlock.hasClass('to-cart__buy')) {
							height = height + $addCartBlock.outerHeight();

							if (height > 0) {
								$jivoBtn.css({
									'bottom': height + 'px',
									'z-index': 100
								});
							}
						}
					});
				} else {
					if ($addCartBlock.length > 0 && checkToCartBlock) {
						height = height + $addCartBlock.outerHeight();
					}

					if (height > 0) {
						$jivoBtn.css({
							'bottom': height + 'px',
							'z-index': 100
						});
					}
				}
			}
		}
	});

	_private.findBtn();
	self.initEventListeners();

	return self;
}
